<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 22 16">
      <path
      d="M14.9 1C14.73 1 14.58 1.09 14.49 1.23L14.42 1.38L9.24 13.03C9.08 13.32 8.98 13.64 8.98 13.99C8.98 15.1 9.88 16 10.99 16C11.95 16 12.76 15.32 12.95 14.41L12.96 14.38L15.4 1.5C15.4 1.22 15.18 1 14.9 1ZM0 5L2 7C4.88 4.12 8.79 2.92 12.53 3.38L13.72 0.700001C8.89 -0.159999 3.74 1.27 0 5ZM20 7L22 5C20.36 3.36 18.45 2.18 16.41 1.43L15.88 4.25C17.38 4.87 18.78 5.78 20 7ZM16 11L18 9C17.2 8.2 16.3 7.58 15.34 7.11L14.79 10.03C15.21 10.3 15.62 10.62 16 11ZM4 9L6 11C7.13 9.87 8.56 9.21 10.03 9L11.31 6.12C8.68 6.04 6.01 6.99 4 9Z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: "Limited",
  props: {
	title: {
	  type: String,
	  default: ""
	},
	decorative: {
	  type: Boolean,
	  default: false
	},
	fillColor: {
	  type: String,
	  default: "currentColor"
	},
	size: {
	  type: Number,
	  default: 24
	}
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/Limited.vue